<div>
  <button
    *showAuthed="community && community.isMember && community.name !== 'uMuzi'"
    (click)="DelMembershipAuthModal.show()"
    type="button"
    class="btn m-b-30 btn-danger"
  >
    <i class="icofont icofont-trash"></i>
    <span>Delete membership?</span>
    <!-- Content marker -->
    <ng-content></ng-content>
  </button>

  <del-membership-auth-modal
    #DelMembershipAuthModal
    [currentUser]="currentUser"
    [community]="community"
    [hideFooter]="true"
  >
  </del-membership-auth-modal>
</div>
